import { ComplianceStatus } from '../types';

export const getComplianceColor = (status: ComplianceStatus) => {
  let color = '';
  switch (status) {
    case 1:
      color = 'color-success';
      break;
    case 2:
      color = 'color-warning';
      break;
    case 3:
      color = 'color-danger';
      break;
    default:
      color = 'color-inactive';
  }
  return color;
};

export const getBackgroundComplianceColor = (status: ComplianceStatus) => {
  let color = '';
  switch (status) {
    case 1:
      color = 'background-success';
      break;
    case 2:
      color = 'background-warning';
      break;
    case 3:
      color = 'background-danger';
      break;
    default:
      color = 'background-inactive';
  }
  return color;
};
